export enum ServiceCallCategoryIconTypeEnum {
  REACT_FEATHER_SHIELD = 'Shield',
  REACT_FEATHER_TOOL = 'Tool',
  REACT_FEATHER_DROPLET = 'Droplet',
  REACT_FEATHER_ALERT_OCTAGON = 'AlertOctagon',
  REACT_FEATHER_SETTINGS = 'Settings',
  REACT_FEATHER_CREDIT_CARDS = 'CreditCard',
  REACT_FEATHER_HELP = 'HelpCircle',
  REACT_FEATHER_MESSAGE_SQUARE = 'MessageSquare',
  REACT_FEATHER_WIND = 'Wind',
  REACT_FEATHER_ELECTRICITY = 'Zap',
  REACT_FEATHER_NOISE = 'Volume',
  REACT_FEATHER_WINDOW = 'Columns',
}
